export default __webpack_public_path__ + "static/media/treasure_chest.f608dd90.svg";